

class AttendeeBudget {
    constructor(){

        this.total_budget = 0;
        this.currency = "USD";

        this.activity_budget = 0.00;
        this.activity_budget_unit = 'Each Activity';           //ea, day, total

        this.lodging_budget = 0.00;
        this.lodging_budget_unit = 'Each Lodging';         //ea, night, total

        this.meal_budget = 0.00;
        this.meal_budget_unit = 'Each Meal';              //ea, day, total

        this.flight_budget = 0.00;
        this.flight_budget_unit = 'Each Direction';          //ea, leg, total

        this.supplies_budget = 0.00;
        this.supplies_budget_unit = 'Each Receipt';        //ea, day, total

        this.incidentals_budget = 0.00;
        this.incidentals_budget_unit = 'Each Receipt';     //ea, day, total

        this.shopping_budget = 0.00;
        this.shopping_budget_unit = 'Each Receipt';        //ea, day, total

        this.transportation_budget = 0.00;
        this.transportation_budget_unit = 'Each Receipt';     //ea, total

        this.private = false;
    }

}

export default AttendeeBudget;
